module.exports = __webpack_public_path__ + "static/media/main-visual-01.9d95794.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/main-visual-01.mp4
// module id = cW4w
// module chunks = 1